import React from "react";
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import "../styles/Footer.css";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <div className="footer">
      <div className="footerContent">

        {/* SOL BLOK */}
        <div className="footerLeft">
          <h4>
            <PhoneInTalkIcon style={{ color: "#335479", marginRight: "6px", verticalAlign: "middle" }} />
            {t('footer.contactUs')}
          </h4>
          <p>
            <WhatsAppIcon />
            <a href="https://wa.me/905376497813" target="_blank" rel="noopener noreferrer">
              +90 (537) 649 78 13
            </a>
          </p>
          <p>
            <WhatsAppIcon />
            <a href="https://wa.me/905412721392" target="_blank" rel="noopener noreferrer">
              +90 (541) 272 13 92
            </a>
          </p>
          <p>
            <MailOutlineIcon />
            <a href="mailto:info@anchmarmarine.com">info@anchmarmarine.com</a>
          </p>
          <p>
            <MailOutlineIcon />
            <a href="mailto:umutmursitoglu@outlook.com">umutmursitoglu@outlook.com</a>
          </p>
          <div className="socialMedia">
            <a href="https://www.instagram.com/anchmarmarine/" target="_blank" rel="noopener noreferrer"><InstagramIcon /></a>
            <a href="mailto:info@anchmarmarine.com" target="_blank" rel="noopener noreferrer"><EmailIcon /></a>
            <a href="https://www.linkedin.com/company/anchmar-marine-ve-mühendislik-danışmanlık-hizmetleri/posts/?feedView=all" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
          </div>
        </div>

        {/* ORTA BLOK */}
        <div className="footerCenter">
          <div className="footerLogoContainer">
            <img src={logo} alt="Anchmar Marine Logo" className="footerLogoImage" />
            <div className="footerLogoText">Anchmar Marine and Consulting</div>
            <p>{t('footer.slogan')}</p>
          </div>
        </div>

        {/* SAĞ BLOK */}
        <div className="footerRight">
          <h4>{t('footer.quickAccess')}</h4>
          <div className="footerLinks">
            <Link to="/">{t('nav.home')}</Link>
            <Link to="/hakkimizda">{t('nav.about')}</Link>
            <Link to="/hizmetlerimiz">{t('nav.services')}</Link>
            <Link to="/fiyatlar">{t('nav.prices', 'Fiyatlar')}</Link>
            <Link to="/gizlilik-politikasi">{t('footer.privacy')}</Link>
            <Link to="/kvkk">{t('footer.kvkk')}</Link>
            <Link to="/iletisim">{t('nav.contact')}</Link>
          </div>
        </div>
      </div>

      <p className="copyright">{t('footer.copyright')}</p>
    </div>
  );
}

export default Footer;
